/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/init-declarations */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { ActionButton, ActionButtonType, Callout, Collapse, ExternalLink, LegacyDataTable, LegacyDataTableBody, LegacyDataTableHeader, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn, RadioButton, RadioButtonGroup, Tooltip, } from "@octopusdeploy/design-system-components";
import { DebounceValue, StringHelper } from "@octopusdeploy/design-system-octopus-components";
import { logger } from "@octopusdeploy/logging";
import { HasGitPersistenceSettings, GuidedFailureMode, HasRunbooksInGit, PackageReferenceNamesMatch, Permission, PriorityMode, ProcessType, TenantedDeploymentMode, DebugMode, OctopusError, ChangeRequestSettingsType, mapFromEnvironmentResourceToEnvironmentV2Resource, isEphemeralEnvironment, toGitTagOrBranchRef, } from "@octopusdeploy/octopus-server-client";
import type { CreateRunbookRunRequestResource, DeploymentPromotionTarget, DeploymentPromotionTenant, DeploymentSettingsResource, FeedResource, FeedType, Form as PromptVariablesForm, FormElement, GitReference, IExecutionResource, ProjectResource, ResourcesById, RunbookProcessResource, RunbookResource, RunbookRunPreviewResource, RunbookRunResource, RunbookRunTemplateResource, RunbooksDashboardItemResource, RunbookSnapshotResource, RunbookSnapshotTemplateResource, TaskResource, TenantResource, SelectedPackage, SelectedGitResource, GitRef, RunGitRunbookCommand, ChangeRequestSettings, RunbookRunResourceWithChangeRequestSettings, CreateRunbookRunRequestResourceWithChangeRequestSettings, EnvironmentV2Resource, StaticEnvironmentV2Resource, } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import cn from "classnames";
import type { Dictionary } from "lodash";
import * as _ from "lodash";
import { cloneDeep, compact, flatten, groupBy, isEqual, keys as lodashKeys } from "lodash";
import type { Moment } from "moment";
import * as PLimit from "p-limit";
import * as React from "react";
import ActionToggle from "~/areas/projects/components/Releases/Deployments/ActionToggle";
import EnvironmentAndTenantSelectorForRunbooks from "~/areas/projects/components/Releases/Deployments/EnvironmentAndTenantSelector/EnvironmentAndTenantSelectorForRunbooks";
import FailTargetDiscoveryOptions from "~/areas/projects/components/Releases/Deployments/FailTargetDiscoveryOptions";
import PendingInterruptions from "~/areas/projects/components/Releases/Deployments/PendingInterruptions";
import PriorityOptions from "~/areas/projects/components/Releases/Deployments/PriorityOptions";
import { GitResourcesSection } from "~/areas/projects/components/Releases/Edit/GitResourcesSection";
import { GitResourcesList } from "~/areas/projects/components/Releases/GitResourcesList";
import { GitReferenceType } from "~/areas/projects/components/Releases/gitResourceModel";
import type { GitReferenceEditInfo, GitReferenceModel } from "~/areas/projects/components/Releases/gitResourceModel";
import type { ProjectContextState } from "~/areas/projects/context";
import { useProjectContext } from "~/areas/projects/context";
import { repository } from "~/clientInstance";
import { RunbookSnapshotPublishedChip } from "~/components/Chips";
import { useSetExpanderState } from "~/components/ControlExpanders/useSetExpanderState";
import DataBaseComponent from "~/components/DataBaseComponent";
import type { Errors } from "~/components/DataBaseComponent/Errors";
import { createErrorsFromOctopusError } from "~/components/DataBaseComponent/Errors";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import type { ProgressDialogStatus } from "~/components/Dialog/ProgressDialog";
import ProgressDialog from "~/components/Dialog/ProgressDialog";
import type { OptionalFormBaseComponentState } from "~/components/FormBaseComponent/FormBaseComponent";
import matchErrorsToFieldNames from "~/components/FormBaseComponent/matchErrorsToFieldNames";
import { LegacyForm } from "~/components/FormPaperLayout/LegacyForm";
import LoadMoreWrapper from "~/components/LoadMoreWrapper/LoadMoreWrapper";
import InternalLink from "~/components/Navigation/InternalLink/InternalLink";
import InternalRedirect from "~/components/Navigation/InternalRedirect/InternalRedirect";
import { PageContent } from "~/components/PageContent/PageContent";
import PermissionCheck, { isAllowed, isAllowedToRunGitRunbook } from "~/components/PermissionCheck/PermissionCheck";
import { ExpandableFormSection, Note, required, Summary, Text } from "~/components/form";
import isBound from "~/components/form/BoundField/isBound";
import { CardFill } from "~/components/form/Sections/ExpandableFormSection";
import { timeOperation, timeOperationOptions } from "~/utils/OperationTimer/timeOperation";
import RequestRaceConditioner from "~/utils/RequestRaceConditioner";
import { useProjectRunbooksGitRef, type GitRefQueryParamsProps } from "../BranchSelector/useProjectGitRef";
import { useEphemeralEnvironmentsEnabled } from "../EphemeralEnvironments/useEphemeralEnvironmentsEnabled";
import DebugOptions from "../Releases/Deployments/DebugOptions";
import type { EnvironmentSelection } from "../Releases/Deployments/EnvironmentAndTenantSelector/EnvironmentSelection";
import { getEnvironmentIds } from "../Releases/Deployments/EnvironmentAndTenantSelector/EnvironmentSelection";
import FailureMode from "../Releases/Deployments/FailureMode";
import ItsmChangeRequestSettings from "../Releases/Deployments/Itsm/ItsmChangeRequestSettings";
import type { JiraServiceManagementProjectSettings, ServiceNowProjectSettings } from "../Releases/Deployments/Itsm/getItsmChangeRequestConfiguration";
import { getChangeControlledEnvironments, getEnabledProjectChangeRequestSettings } from "../Releases/Deployments/Itsm/getItsmChangeRequestConfiguration";
import { default as NowOrLater, NowOrLaterEnum } from "../Releases/Deployments/NowOrLater/NowOrLater";
import PackageDownloadOptions from "../Releases/Deployments/PackageDownloadOptions";
import type { DeploymentMachineInfo } from "../Releases/Deployments/Preview";
import { DeploymentPreview, DeploymentType } from "../Releases/Deployments/Preview";
import PromptVariables from "../Releases/Deployments/PromptVariables";
import type CurrentVersionMap from "../Releases/Deployments/currentVersionMap";
import type { DeploymentRequestModel } from "../Releases/Deployments/deploymentRequestModel";
import { loadPendingInterruptions } from "../Releases/Deployments/pendingInterruptionUtil";
import { GitRefChip } from "../Releases/GitRefChip/GitRefChip";
import PackageListDialogContent from "../Releases/PackageListDialog/PackageListDialogContent";
import PackagesList from "../Releases/PackagesList/PackagesList";
import { VersionType } from "../Releases/packageModel";
import type { PackageEditInfo, PackageModel } from "../Releases/packageModel";
import { RunbookSnapshotInformation } from "./LastPublishedChip";
import { useRunbookContext } from "./RunbookContext";
import { RunbookNoPermissionsPage } from "./RunbookNoPermissionsPage";
import styles from "./RunbookRunNowLayout.module.less";
import { isRunbookConsumerTryingToRunAnUnpublishedSnapshot } from "./isRunbookConsumerTryingToRunAnUnpublishedSnapshot";
import { useNewRunbookRunsListPageFeatureToggle } from "./useNewRunbookRunsListPageFeatureToggle";
const versionExpanderKey = "version";
const DebounceText = DebounceValue(Text);
type RetryGoal = {
    previousRunbookRunId: string;
};
type NewRun = {
    tenantIds?: string[];
    environmentIds?: string[];
    tenantTags?: string[];
};
export type RunGoal = RetryGoal | NewRun;
export function isNewRun(goal: RunGoal): goal is NewRun {
    return !("previousRunbookRunId" in goal && Boolean(goal.previousRunbookRunId));
}
enum RunType {
    CreateNew = "CreateNew",
    Published = "Published"
}
export enum DeploymentModelType {
    Deployment = "Deployment",
    Runbook = "Runbook"
}
interface AvailableRunsApiResults {
    allowRun: boolean;
    previews: Map<string, RunbookRunPreviewResource>;
    promptVariablesForm: PromptVariablesForm;
    requests: DeploymentRequestModel[];
}
interface RunbookRunNowLayoutModel {
    editingPackages: PackageEditInfo[];
    readonlyPackages: PackageModel[];
    editingGitResources: GitReferenceEditInfo[];
    readonlyGitResources: GitReferenceModel[];
    runbookSnapshot: RunbookSnapshotResource;
}
interface RunbookRunNowLayoutInternalProps extends RunbookRunNowLayoutProps {
    runbook: RunbookResource;
    project: ProjectResource;
    gitRef: Readonly<GitRef> | undefined;
    gitRefError: string | undefined;
    setExpanderState(key: string, open: boolean): void;
    newRunbookRunsListPageEnabled: boolean;
    ephemeralEnvironmentsAreEnabled: boolean;
    projectContextState: ProjectContextState;
}
export type PromotionsMap = {
    [id: string]: DeploymentPromotionTarget | DeploymentPromotionTenant;
};
interface RunbookRunNowLayoutState extends OptionalFormBaseComponentState<RunbookRunNowLayoutModel> {
    model: RunbookRunNowLayoutModel;
    cleanModel: RunbookRunNowLayoutModel;
    deploymentSettings: DeploymentSettingsResource;
    runbookProcess: RunbookProcessResource;
    runbookSnapshotTemplate: RunbookSnapshotTemplateResource;
    redirect: boolean;
    defaultCheckModel: RunbookRunNowLayoutModel;
    feeds: ResourcesById<FeedResource>;
    previousRunbookRun: RunbookRunResource;
    nowOrLater: NowOrLaterEnum;
    forcePackageDownload: boolean;
    failTargetDiscovery: boolean;
    defaultGuidedFailureMode: GuidedFailureMode;
    guidedFailureMode: GuidedFailureMode;
    actionIdsToSkip: string[];
    runbookRunRequests: DeploymentRequestModel[];
    queueTime: Moment;
    queueTimeExpiry: Moment;
    priority: PriorityMode;
    selectedEnvironments: EnvironmentSelection[];
    selectedTenantIds: string[];
    redirectPath?: LinkHref;
    promptVariablesForm: PromptVariablesForm;
    promotionsMap: PromotionsMap;
    runbookRunTemplate: RunbookRunTemplateResource;
    missingTenantVariablesLoading: boolean;
    missingTenantVariables: Dictionary<string[]>;
    allEnvironments: EnvironmentV2Resource[];
    allStaticEnvironments: StaticEnvironmentV2Resource[];
    allTenants: TenantResource[];
    pendingInterruptions: Array<TaskResource<any>>;
    currentVersionMap: CurrentVersionMap;
    previews: Map<string, RunbookRunPreviewResource>;
    previousRunbookRunBeingRetried?: RunbookRunResource;
    showAdvanced: boolean;
    currentDashboardItems: RunbooksDashboardItemResource[];
    runType?: RunType;
    isReloading: boolean;
    publishedRunbookSnapshot: RunbookSnapshotResource;
    isPublishNeeded: boolean;
    numOfRunbookRunsToBeCreated: number | null;
    numOfRunbookRunsCreated: number;
    gitRepoErrors: string[];
    hideGitRepoErrorDetails: boolean;
    isGitRunbook: boolean;
    debugMode: DebugMode;
    changeRequestSettings?: ChangeRequestSettings[];
}
const MaximumInterruptionsToLoad = 10;
class RunbookRunNowLayoutInternal extends DataBaseComponent<RunbookRunNowLayoutInternalProps, RunbookRunNowLayoutState> {
    memoizedRepositoryChannelsRuleTest = _.memoize((version: string, versionRange: string, preReleaseTag: string, feedType: FeedType) => repository.Channels.ruleTest({
        version,
        versionRange,
        preReleaseTag,
        feedType,
    }));
    private existingRunbookSnapshotId: string = undefined!;
    private runRaceConditioner = new RequestRaceConditioner();
    constructor(props: RunbookRunNowLayoutInternalProps) {
        super(props);
        this.state = {
            model: null!,
            cleanModel: null!,
            deploymentSettings: null!,
            runbookProcess: null!,
            runbookSnapshotTemplate: null!,
            redirect: false,
            defaultCheckModel: null!,
            feeds: null!,
            previousRunbookRun: null!,
            missingTenantVariablesLoading: false,
            missingTenantVariables: {},
            nowOrLater: NowOrLaterEnum.Now,
            forcePackageDownload: false,
            defaultGuidedFailureMode: GuidedFailureMode.EnvironmentDefault,
            guidedFailureMode: GuidedFailureMode.EnvironmentDefault,
            actionIdsToSkip: [],
            runbookRunRequests: [],
            queueTime: null!,
            queueTimeExpiry: null!,
            priority: PriorityMode.Off,
            selectedEnvironments: [],
            selectedTenantIds: [],
            promptVariablesForm: null!,
            promotionsMap: null!,
            runbookRunTemplate: null!,
            allEnvironments: [],
            allStaticEnvironments: [],
            allTenants: [],
            pendingInterruptions: [],
            currentVersionMap: null!,
            previews: new Map<string, RunbookRunPreviewResource>(),
            previousRunbookRunBeingRetried: null!,
            showAdvanced: false,
            currentDashboardItems: [],
            runType: null!,
            isReloading: false,
            publishedRunbookSnapshot: null!,
            isPublishNeeded: false,
            numOfRunbookRunsToBeCreated: null,
            numOfRunbookRunsCreated: 0,
            gitRepoErrors: [],
            hideGitRepoErrorDetails: true,
            isGitRunbook: HasRunbooksInGit(props.project.PersistenceSettings),
            debugMode: DebugMode.None,
            changeRequestSettings: [],
            failTargetDiscovery: false,
        };
    }
    async componentDidMount() {
        await this.reload();
    }
    async componentDidUpdate(prevProps: RunbookRunNowLayoutInternalProps) {
        const nextRunbook = this.props.runbook;
        const nextGitRef = this.props.gitRef;
        const currentRunbook = prevProps.runbook;
        const currentGitRef = prevProps.gitRef;
        if (!isEqual(currentRunbook, nextRunbook) || !isEqual(currentGitRef, nextGitRef)) {
            await this.reload();
        }
    }
    async loadRunbookSnapshot(project: ProjectResource, runbook: RunbookResource, publishedRunbookSnapshot: RunbookSnapshotResource): Promise<RunbookSnapshotResource> {
        let runbookSnapshot: RunbookSnapshotResource;
        if (this.existingRunbookSnapshotId) {
            if (this.existingRunbookSnapshotId === runbook.PublishedRunbookSnapshotId) {
                // Save a lookup.
                runbookSnapshot = publishedRunbookSnapshot;
            }
            else {
                runbookSnapshot = await repository.RunbookSnapshots.get(this.existingRunbookSnapshotId);
            }
        }
        else {
            runbookSnapshot = {
                ProjectId: project.Id,
                ProjectVariableSetSnapshotId: project.VariableSetId,
                LibraryVariableSetSnapshotIds: project.IncludedLibraryVariableSetIds,
                RunbookId: runbook.Id,
                FrozenRunbookProcessId: runbook.RunbookProcessId, // We need this to fake a preview (since that uses the frozen id)
                FrozenProjectVariableSetId: project.VariableSetId,
                SelectedPackages: [],
                SelectedGitResources: [],
            } as unknown as RunbookSnapshotResource; // Need to cast to avoid adding null entries for various properties, which blows up the API.
            if (this.state.isGitRunbook && this.props.gitRef) {
                runbookSnapshot.GitReference = {
                    GitRef: this.props.gitRef,
                };
            }
        }
        return runbookSnapshot;
    }
    async reload() {
        const project = this.props.project;
        const runbook = this.props.runbook;
        await timeOperation(timeOperationOptions.forInitialLoad(project.IsVersionControlled), async () => {
            if (project.IsVersionControlled && !HasRunbooksInGit(project.PersistenceSettings)) {
                // Check that the Git variables can be retrieved successfully.
                try {
                    await this.props.projectContextState.projectContextRepository.Variables.get();
                }
                catch (ex) {
                    const gitRepoErrors = [ex.ErrorMessage];
                    // Add any additional details about the error. This is often where the really useful stuff is.
                    ex.Errors?.forEach((error: any) => {
                        if (error) {
                            gitRepoErrors.push(error);
                        }
                    });
                    await this.setStateAsync({ ...this.state, gitRepoErrors: gitRepoErrors });
                }
            }
            const runType = this.state.runType ? this.state.runType : RunType.Published;
            this.setExistingRunbookSnapshotId(runType);
            await this.setStateAsync({ ...this.state, isReloading: true });
            try {
                if (this.state.isGitRunbook && !this.props.gitRef) {
                    return;
                }
                await this.doBusyTask(async () => {
                    let publishedRunbookSnapshot: RunbookSnapshotResource;
                    if (runbook.PublishedRunbookSnapshotId) {
                        publishedRunbookSnapshot = await repository.RunbookSnapshots.get(runbook.PublishedRunbookSnapshotId);
                    }
                    const runbookSnapshot = await this.loadRunbookSnapshot(project, runbook, publishedRunbookSnapshot!);
                    const notPublishedAndUserNoPermissionToPublish = !this.existingRunbookSnapshotId &&
                        !isAllowed({
                            permission: Permission.RunbookEdit,
                            project: project.Id,
                            wildcard: true,
                        });
                    if (!this.state.isGitRunbook && notPublishedAndUserNoPermissionToPublish) {
                        this.setState({ isPublishNeeded: true });
                        return;
                    }
                    const runbookRunTemplate = this.existingRunbookSnapshotId
                        ? await repository.RunbookSnapshots.getRunbookRunTemplate(runbookSnapshot)
                        : await repository.Runbooks.getRunbookRunTemplate(project, runbook.Id, this.state.isGitRunbook ? this.props.gitRef : undefined);
                    const allEnvsPromise = this.loadEnvironments(this.props.ephemeralEnvironmentsAreEnabled, project, runbook.Id, this.state.isGitRunbook ? this.props.gitRef : undefined);
                    const previousRunbookRun = isNewRun(this.props.goal) ? null : await repository.RunbookRuns.get(this.props.goal.previousRunbookRunId);
                    const allTenantsPromise = this.loadAllTenants(runbook);
                    this.setState({ missingTenantVariablesLoading: true });
                    this.loadMissingTenantVariables(project, runbook)
                        .then((missingTenantVariables) => {
                        this.setState({ missingTenantVariables, missingTenantVariablesLoading: false });
                    })
                        .catch(() => {
                        this.setState({ missingTenantVariablesLoading: false });
                    });
                    const guidedFailureMode = isNewRun(this.props.goal) ? runbook.DefaultGuidedFailureMode : previousRunbookRun!.UseGuidedFailure ? GuidedFailureMode.On : GuidedFailureMode.Off;
                    const actionIdsToSkip = !isNewRun(this.props.goal) && previousRunbookRun!.SkipActions.length > 0 ? previousRunbookRun!.SkipActions : [];
                    const forcePackageDownload = isNewRun(this.props.goal) ? runbook.ForcePackageDownload : previousRunbookRun!.ForcePackageDownload;
                    const failTargetDiscovery = isNewRun(this.props.goal) ? runbook.FailTargetDiscovery : previousRunbookRun!.FailTargetDiscovery;
                    const stepsPromise = this.loadSteps(project, runbook.RunbookProcessId, this.state.isGitRunbook ? this.props.gitRef : undefined);
                    // Get progression so we can see if this snapshot has already been run for any tenants (so we show an option). We don't support
                    // re-running snapshots for Git projects, so we don't need this if we're running a Git Runbook.
                    const progressionPromise = this.state.isGitRunbook ? Promise.resolve(undefined) : repository.Progression.getRunbookProgression(runbook);
                    const [feeds, runbookProcess, progression] = await Promise.all([repository.Feeds.allById(), stepsPromise, progressionPromise]);
                    const cleanModel: RunbookRunNowLayoutModel = {
                        editingPackages: [],
                        readonlyPackages: [],
                        editingGitResources: [],
                        readonlyGitResources: [],
                        runbookSnapshot: null!,
                    };
                    const model = this.buildModel(runbookSnapshot, [], [], [], []);
                    await this.loadRunbookSnapshotTemplate(project, model, runbook, this.state.isGitRunbook ? this.props.gitRef : undefined);
                    const currentDashboardItems = progression ? flatten(Object.values(progression.RunbookRuns)) : [];
                    const gitRef = HasGitPersistenceSettings(project.PersistenceSettings) && !HasRunbooksInGit(project.PersistenceSettings) ? project.PersistenceSettings.DefaultBranch : this.props.gitRef;
                    const deploymentSettings = await repository.ProjectDeploymentSettings.get(project.Id, gitRef);
                    const previousChangeRequestSettings = (previousRunbookRun as RunbookRunResourceWithChangeRequestSettings)?.ChangeRequestSettings;
                    const allEnvironments = await allEnvsPromise;
                    const allStaticEnvironments = allEnvironments.filter((e) => e.Type === "Static");
                    this.setState({
                        deploymentSettings,
                        runbookProcess,
                        model,
                        cleanModel: cleanModel ? cleanModel : cloneDeep(model),
                        defaultCheckModel: cloneDeep(model),
                        feeds,
                        runbookRunTemplate,
                        promotionsMap: this.buildPromotionsMap(runbookRunTemplate),
                        previousRunbookRun: previousRunbookRun!,
                        defaultGuidedFailureMode: runbook.DefaultGuidedFailureMode,
                        guidedFailureMode,
                        actionIdsToSkip,
                        allEnvironments,
                        allStaticEnvironments,
                        allTenants: await allTenantsPromise,
                        forcePackageDownload,
                        previousRunbookRunBeingRetried: isNewRun(this.props.goal) ? undefined : previousRunbookRun!,
                        currentDashboardItems,
                        publishedRunbookSnapshot: publishedRunbookSnapshot!,
                        runType,
                        changeRequestSettings: previousChangeRequestSettings,
                        failTargetDiscovery,
                    });
                });
            }
            finally {
                this.setState({ isReloading: false });
            }
        });
    }
    setExistingRunbookSnapshotId(runType: RunType) {
        const runbook = this.props.runbook;
        this.existingRunbookSnapshotId = null!;
        if (this.props.runbookSnapshotId) {
            this.existingRunbookSnapshotId = this.props.runbookSnapshotId;
        }
        else if (runbook.PublishedRunbookSnapshotId && runType === RunType.Published) {
            this.existingRunbookSnapshotId = runbook.PublishedRunbookSnapshotId;
        }
    }
    isUsingPublishedSnapshot() {
        const runbook = this.props.runbook;
        return this.existingRunbookSnapshotId && this.existingRunbookSnapshotId === runbook.PublishedRunbookSnapshotId;
    }
    render() {
        if (this.state.redirectPath) {
            return <InternalRedirect to={this.state.redirectPath} push={true}/>;
        }
        if (this.state.isPublishNeeded) {
            return (<PageContent header={{ title: "" }} callout={{
                    type: "information",
                    title: "This runbook has not been published",
                    content: "As a runbook consumer, you can only work with already published runbooks. Please contact your Octopus administrator if you need help to work out who owns the runbook and is responsible for publishing it.",
                }}>
                    {null}
                </PageContent>);
        }
        const project = this.props.project;
        const runbook = this.props.runbook;
        const hasLoaded = !!this.state.runbookProcess;
        const hasSteps = this.state.runbookProcess && this.state.runbookProcess.Steps && this.state.runbookProcess.Steps.length > 0;
        const isConsumerTryingToRunAnUnpublished = this.state.isGitRunbook ? false : isRunbookConsumerTryingToRunAnUnpublishedSnapshot(project, runbook, this.existingRunbookSnapshotId);
        const isSaveEnabled = !this.state.busy && this.checkCanDeploy(this.state.selectedEnvironments, this.state.selectedTenantIds);
        if (this.state.isGitRunbook && !isAllowedToRunGitRunbook(this.props.project, this.props.gitRef)) {
            return (<PageContent header={{ title: "" }}>
                    <RunbookNoPermissionsPage />
                </PageContent>);
        }
        const gitRefError = this.props.gitRefError ? [{ name: "Git repository error", message: this.props.gitRefError }] : undefined;
        return (<>
                <LegacyForm model={this.state.model} cleanModel={this.state.cleanModel} onSaveClick={() => this.onRunNowClicked(false)} forceDisableFormSaveButton={!isSaveEnabled || !hasSteps || isConsumerTryingToRunAnUnpublished} saveText="Runbook started" disableDirtyFormChecking={true} savePermission={{ permission: Permission.RunbookRunCreate, project: project && project.Id, wildcard: true }}>
                    {({ FormContent, createSaveAction }) => (<PageContent header={{
                    title: this.formTitle(),
                    chip: this.formTitleChip(),
                    primaryAction: createSaveAction({
                        saveButtonLabel: "Run",
                        saveButtonBusyLabel: "Running...",
                    }),
                    breadcrumbs: runbook
                        ? [
                            { label: "Runbooks", pageUrl: links.runbooksPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug }) },
                            {
                                label: runbook.Name,
                                pageUrl: this.props.newRunbookRunsListPageEnabled
                                    ? links.runbookRunsPage.generateUrl({ spaceId: this.props.project.SpaceId, projectSlug: this.props.project.Slug, runbookId: runbook.Id })
                                    : links.runbookOverviewPage.generateUrl({ spaceId: this.props.project.SpaceId, projectSlug: this.props.project.Slug, runbookId: runbook.Id }),
                            },
                        ]
                        : undefined,
                }} busy={this.state.busy} errors={this.errors ?? gitRefError}>
                            <FormContent hideExpandAll={true}>
                                {hasLoaded &&
                    (hasSteps ? (<>
                                            {isConsumerTryingToRunAnUnpublished ? (<Callout type={"danger"} title="Runbook Consumer">
                                                    Your permissions only allow you to run published snapshots.
                                                </Callout>) : (this.runbookRunConfigurationForm())}
                                        </>) : (<Callout type={"danger"} title="No Steps To Run">
                                            Please make sure you have some steps assigned to this Runbook before attempting to run.&nbsp;
                                            <PermissionCheck permission={Permission.RunbookEdit} project={project.Id} wildcard={true}>
                                                <InternalLink to={links.runbookProcessPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug, runbookId: runbook.Id, processId: runbook.RunbookProcessId })}>
                                                    Define your Runbook Process
                                                </InternalLink>
                                            </PermissionCheck>
                                        </Callout>))}
                            </FormContent>
                        </PageContent>)}
                </LegacyForm>
                {this.progressDialog()}
            </>);
    }
    private progressDialog() {
        const { numOfRunbookRunsToBeCreated, numOfRunbookRunsCreated } = this.state;
        const singleRun = numOfRunbookRunsToBeCreated === 1;
        const title = `Creating ${numOfRunbookRunsToBeCreated} run${singleRun ? "" : "s"}`;
        const content = `Please wait while the run${singleRun ? " is" : "s are"} created.`;
        const progressStatus: ProgressDialogStatus = numOfRunbookRunsToBeCreated === null ? { type: "not in progress" } : { type: "in progress", percentComplete: Math.min((numOfRunbookRunsCreated / numOfRunbookRunsToBeCreated) * 100, 100) };
        return <ProgressDialog title={title} content={content} status={progressStatus}/>;
    }
    private formTitle(): string {
        if (this.state.isGitRunbook) {
            const runbook = this.props.runbook;
            return `Run ${runbook.Name}`;
        }
        const runbookSnapshot = this.state.model && this.state.model.runbookSnapshot;
        const snapshotName = (runbookSnapshot && runbookSnapshot.Name) || StringHelper.ellipsis;
        return `Run ${snapshotName}`;
    }
    private formTitleChip(): React.ReactElement | undefined {
        const gitRef = this.props.gitRef;
        const runbook = this.props.runbook;
        const runbookSnapshot = this.state.model && this.state.model.runbookSnapshot;
        if (this.state.isGitRunbook && gitRef) {
            return <GitRefChip vcsRef={{ GitRef: gitRef }} showCommit={false}/>;
        }
        return runbook.PublishedRunbookSnapshotId && runbookSnapshot && runbookSnapshot.Id === runbook.PublishedRunbookSnapshotId ? <RunbookSnapshotPublishedChip noMargin={true}/> : undefined;
    }
    private buildModel(release: RunbookSnapshotResource, packageSelections: PackageEditInfo[], readonlyPackages: PackageModel[], gitResourceSelection: GitReferenceEditInfo[], readonlyGitResources: GitReferenceModel[]): RunbookRunNowLayoutModel {
        const model: RunbookRunNowLayoutModel = {
            editingPackages: packageSelections,
            readonlyPackages,
            editingGitResources: gitResourceSelection,
            readonlyGitResources,
            runbookSnapshot: release,
        };
        return model;
    }
    private loadSteps = async (project: ProjectResource, runbookId: string, gitRef?: string) => {
        return await repository.Runbooks.getRunbookProcess(project.Id, project.SpaceId, runbookId, gitRef);
    };
    private async loadRunbookSnapshotTemplate(project: ProjectResource, model: RunbookRunNowLayoutModel, runbook: RunbookResource, gitRef: string | undefined) {
        let runbookSnapshotTemplate: RunbookSnapshotTemplateResource;
        if (this.existingRunbookSnapshotId) {
            const runbookProcess = await repository.RunbookProcess.get(model.runbookSnapshot.FrozenRunbookProcessId);
            runbookSnapshotTemplate = await repository.RunbookProcess.getRunbookSnapshotTemplate(runbookProcess, model.runbookSnapshot.Id);
        }
        else {
            runbookSnapshotTemplate = await repository.Runbooks.getRunbookSnapshotTemplate(project, runbook.Id, gitRef);
        }
        if (!this.existingRunbookSnapshotId && runbookSnapshotTemplate.NextNameIncrement) {
            model.runbookSnapshot.Name = runbookSnapshotTemplate.NextNameIncrement;
        }
        const existingPackageSelections: {
            [key: string]: string;
        } = {};
        if (model.runbookSnapshot.SelectedPackages) {
            for (const p of model.runbookSnapshot.SelectedPackages) {
                existingPackageSelections[this.createPackageKey(p)] = p.Version;
            }
        }
        const existingGitResourceSelections: {
            [key: string]: GitReference;
        } = {};
        if (model.runbookSnapshot.SelectedGitResources) {
            for (const p of model.runbookSnapshot.SelectedGitResources) {
                existingGitResourceSelections[p.ActionName] = p.GitReferenceResource;
            }
        }
        const selectionByFeed: {
            [feedId: string]: PackageEditInfo[];
        } = {};
        const packageSelections = [];
        for (const p of runbookSnapshotTemplate.Packages) {
            const specificVersion = existingPackageSelections[this.createPackageKey(p)] ?? "";
            const isResolvable = p.IsResolvable;
            const lastReleaseVersion = p.VersionSelectedLastRelease;
            const selection: PackageEditInfo = {
                ActionName: p.ActionName,
                PackageReferenceName: p.PackageReferenceName,
                PackageId: p.PackageId,
                ProjectName: p.ProjectName,
                FeedId: p.FeedId,
                FeedName: p.FeedName,
                LatestVersion: "",
                SpecificVersion: specificVersion,
                IsResolvable: isResolvable,
                LastReleaseVersion: lastReleaseVersion,
                FixedVersion: p.FixedVersion,
                VersionType: specificVersion ? VersionType.specific : isResolvable ? VersionType.latest : lastReleaseVersion ? VersionType.last : VersionType.specific,
                IsLastReleaseVersionValid: !isBound(p.FeedId),
            };
            packageSelections.push(selection);
            if (selection.IsResolvable) {
                if (!selectionByFeed[selection.FeedId]) {
                    selectionByFeed[selection.FeedId] = [];
                }
                selectionByFeed[selection.FeedId].push(selection);
            }
        }
        const gitResourceSelections = [];
        for (const p of runbookSnapshotTemplate.GitResources ?? []) {
            const specificGitReference = existingGitResourceSelections[p.ActionName];
            const selection: GitReferenceEditInfo = {
                ActionName: p.ActionName,
                GitCredentialId: p.GitCredentialId,
                GitHubConnectionId: p.GitHubConnectionId,
                RepositoryUri: p.RepositoryUri,
                DefaultBranch: p.DefaultBranch,
                IsResolvable: p.IsResolvable,
                FilePathFilters: p.FilePathFilters,
                LastGitResource: p.GitResourceSelectedLastRelease,
                SpecificGitResource: specificGitReference ?? { GitRef: toGitTagOrBranchRef(p.DefaultBranch) },
                GitReferenceType: GitReferenceType.specific,
                GitResourceReferenceName: p.Name,
            };
            gitResourceSelections.push(selection);
        }
        await this.setStateAsync({ ...this.state, runbookSnapshotTemplate });
        await this.loadVersions(model, selectionByFeed); // This function depends on template being in state.
        model.editingPackages = packageSelections;
        model.editingGitResources = gitResourceSelections;
        const readonlyPackages: PackageModel[] = runbookSnapshotTemplate
            ? compact(runbookSnapshotTemplate.Packages.map((packageTemplate) => {
                const selectionForStep = model.runbookSnapshot.SelectedPackages.find((selected) => selected.ActionName === packageTemplate.ActionName && PackageReferenceNamesMatch(selected.PackageReferenceName!, packageTemplate.PackageReferenceName!));
                if (selectionForStep) {
                    return {
                        ActionName: packageTemplate.ActionName,
                        PackageId: packageTemplate.PackageId,
                        PackageReferenceName: packageTemplate.PackageReferenceName!,
                        ProjectName: packageTemplate.ProjectName,
                        FeedName: packageTemplate.FeedName,
                        FeedId: packageTemplate.FeedId,
                        Version: (selectionForStep as any).Version,
                        Notes: {
                            Notes: null,
                            Succeeded: true,
                            FailureReason: null,
                            Published: null,
                        },
                    };
                }
            }))
            : [];
        model.readonlyPackages = readonlyPackages;
        model.readonlyGitResources = runbookSnapshotTemplate
            ? compact(runbookSnapshotTemplate.GitResources?.map((gitResource) => {
                const selectionForStep = model.runbookSnapshot.SelectedGitResources.find((selected) => selected.ActionName === gitResource.ActionName);
                if (selectionForStep) {
                    return {
                        ActionName: gitResource.ActionName,
                        RepositoryUri: gitResource.RepositoryUri,
                        FilePathFilters: gitResource.FilePathFilters,
                        GitResource: selectionForStep.GitReferenceResource ?? gitResource.GitResourceSelectedLastRelease,
                        GitResourceReferenceName: gitResource.Name,
                    };
                }
            }))
            : [];
        this.setState({ model });
        if (!model.runbookSnapshot.Name) {
            this.props.setExpanderState(versionExpanderKey, true);
        }
    }
    private loadVersions(model: RunbookRunNowLayoutModel, selectionsByFeed: Dictionary<PackageEditInfo[]>): Promise<boolean> {
        const memoizedRepositoryFeedsGet = _.memoize((id: string) => repository.Feeds.get(id));
        const checkForRuleSatisfaction = async (selection: PackageEditInfo, filters: {
            versionRange?: string;
            preReleaseTag?: string;
        }, feedType: FeedType) => {
            if (selection.LastReleaseVersion) {
                const result = await this.memoizedRepositoryChannelsRuleTest(selection.LastReleaseVersion, filters.versionRange!, filters.preReleaseTag!, feedType);
                selection.IsLastReleaseVersionValid = result.SatisfiesVersionRange && result.SatisfiesPreReleaseTag;
            }
            else {
                selection.IsLastReleaseVersionValid = false;
            }
        };
        const getPackageVersion = async (feedId: string): Promise<any> => {
            const feed = await memoizedRepositoryFeedsGet(feedId);
            const selections = selectionsByFeed[feedId];
            const packageSearchGroups = groupBy(selections.map((selection) => ({ selection, filter: {} })), ({ selection, filter }) => selection.PackageId + JSON.stringify(filter || {}));
            const t = Object.values(packageSearchGroups).map(async (sameFilteredPackages) => {
                const releases = (await repository.Feeds.searchPackageVersions(feed, sameFilteredPackages[0].selection.PackageId, {
                    ...sameFilteredPackages[0].filter,
                    take: 1,
                })).Items;
                return sameFilteredPackages.map(async ({ selection, filter }) => {
                    await checkForRuleSatisfaction(selection, filter, feed.FeedType);
                    if (releases.length === 0) {
                        // no latest version found
                        selection.IsResolvable = false;
                        // Docker feeds may not conform to semver, in which case there will be no valid versions.
                        // However you can manually enter a version like "latest", and this will be shown as the
                        // last version. It is convenient to select that last version rather than default to
                        // the specific version field.
                        selection.VersionType = selection.LastReleaseVersion ? VersionType.last : VersionType.specific;
                        return this.setVersionSatisfaction(selection, null!);
                    }
                    const pkg = releases[0];
                    selection.LatestVersion = pkg.Version;
                    if (!model.runbookSnapshot.Id) {
                        return this.packageVersionChanged(model, selection, pkg.Version, null!);
                    }
                    return this.setVersionSatisfaction(selection, null!);
                });
            });
            return Promise.all(flatten(await Promise.all(t)));
        };
        return this.doBusyTask(async () => {
            return Promise.all(lodashKeys(selectionsByFeed)
                .filter((f) => !isBound(f))
                .map((f) => getPackageVersion(f)));
        });
    }
    private packageVersionChanged = (m: RunbookRunNowLayoutModel, pkg: PackageEditInfo, version: string, versionType: VersionType) => {
        const runbookSnapshotModel = { ...m };
        if (versionType) {
            pkg.VersionType = versionType;
            if (versionType === VersionType.specific) {
                pkg.SpecificVersion = version;
            }
        }
        if (!isBound(pkg.FeedId) && this.state.feeds) {
            const feed = this.state.feeds[pkg.FeedId];
            if (feed) {
                this.setVersionSatisfaction(pkg, versionType);
            }
        }
        this.setState({ model: runbookSnapshotModel });
    };
    private setVersionSatisfaction = (pkg: PackageEditInfo, versionType: VersionType) => {
        if (versionType) {
            pkg.VersionType = versionType;
        }
    };
    private showGitRepoErrorCallout = () => this.state.gitRepoErrors.length > 0;
    private renderGitRepoErrorCallout = () => {
        if (!this.showGitRepoErrorCallout()) {
            return null;
        }
        const gitRepoErrors: JSX.Element[] = [];
        this.state.gitRepoErrors.forEach((error) => {
            gitRepoErrors.push(<div>{error}</div>);
        });
        const calloutType = this.isThereNothingToRun() ? "danger" : "warning";
        const introText = this.isThereNothingToRun()
            ? "There was an error retrieving the variables from the Git repository. The runbook can not be run until the error is resolved."
            : "There was an error retrieving the variables from the Git repository. The current draft can not be run until the error is resolved.";
        return (<Callout type={calloutType} title="Git repository error">
                <div>{introText}</div>
                <ActionButton label={this.state.hideGitRepoErrorDetails ? "Show details" : "Hide details"} type={ActionButtonType.Ternary} onClick={() => this.setState({ hideGitRepoErrorDetails: !this.state.hideGitRepoErrorDetails })}/>
                {!this.state.hideGitRepoErrorDetails && gitRepoErrors}
            </Callout>);
    };
    private runbookRunConfigurationForm() {
        const runbookRunTemplate = this.state.runbookRunTemplate;
        const selectedEnvironmentIds = getEnvironmentIds(this.state.selectedEnvironments);
        const tenantsWithMissingVariables = ((selectedEnvironmentIds.length > 0 && this.state.missingTenantVariables[selectedEnvironmentIds[0]]) || []).filter((tenantId) => this.state.selectedTenantIds.indexOf(tenantId) !== -1);
        const hasEditingPackages = this.state.model && this.state.model.editingPackages && this.state.model.editingPackages.length > 0;
        const hasEditingGitResources = this.state.model && this.state.model.editingGitResources && this.state.model.editingGitResources.length > 0;
        if (this.showGitRepoErrorCallout() && this.isThereNothingToRun()) {
            // As there is nothing to run, just display the callout and nothing else.
            return this.renderGitRepoErrorCallout();
        }
        const projectChangeRequestSettings = getEnabledProjectChangeRequestSettings(this.state.allStaticEnvironments.filter((e) => selectedEnvironmentIds.indexOf(e.Id) !== -1), this.props.project);
        return (<div>
                {this.state && this.state.model && this.state.model.runbookSnapshot && (<div>
                        {runbookRunTemplate && (!runbookRunTemplate.PromoteTo || runbookRunTemplate.PromoteTo.length === 0) && (<Callout title="Note" type={"warning"}>
                                Before you can run this operation, you need to <InternalLink to={links.environmentsPage.generateUrl({ spaceId: this.props.runbook.SpaceId })}>add an environment</InternalLink> to deploy it to.
                            </Callout>)}
                        <PendingInterruptions pendingInterruptions={this.state.pendingInterruptions}/>
                        {this.existingRunbookSnapshotId && this.state.model.runbookSnapshot.Notes && (<Callout type={"information"} title={"Notes"}>
                                {this.state.model.runbookSnapshot.Notes}
                            </Callout>)}
                        {runbookRunTemplate && (<EnvironmentAndTenantSelectorForRunbooks project={this.props.project} template={runbookRunTemplate} tenantedDeploymentMode={this.props.runbook.MultiTenancyMode} onSelectionUpdated={this.onSelectionUpdated} tenantsWithMissingVariables={tenantsWithMissingVariables} missingTenantVariablesLoading={this.state.missingTenantVariablesLoading} onDoingBusyTask={this.doBusyTask} runbook={this.props.runbook} runbookSnapshot={this.state.model.runbookSnapshot} allTenants={this.state.allTenants.filter((t) => !t.IsDisabled)} allEnvironments={this.state.allEnvironments} goal={isNewRun(this.props.goal) ? this.props.goal : getRetryGoalForSelector(this.props.goal, this.state.previousRunbookRun)} currentDashboardItems={this.state.currentDashboardItems}/>)}
                        {this.state.promptVariablesForm && this.state.promptVariablesForm.Elements.length > 0 && (<PromptVariables form={this.state.promptVariablesForm} onParameterChanged={(variable) => {
                        const promptVariablesForm = { ...this.state.promptVariablesForm };
                        promptVariablesForm.Values[variable.VariableName] = variable.Value;
                        this.setState({ promptVariablesForm });
                    }} processType={ProcessType.Runbook}/>)}
                        {this.publishedSnapshotExists() && (<PermissionCheck permission={Permission.RunbookEdit} project={this.state.publishedRunbookSnapshot.ProjectId} wildcard={true}>
                                <ExpandableFormSection errorKey="snapshot" title="Snapshot" help={"Select the snapshot behaviour"} summary={this.snapshotSummary()} isExpandedByDefault={true} containerKey="runbooksRun-Snapshot">
                                    <RadioButtonGroup value={this.state.runType!} onChange={this.onChangeRunType}>
                                        <RadioButton value={RunType.Published} label="Published" isDefault={true}/>
                                        <Note>
                                            This will re-use the existing published snapshot{" "}
                                            <InternalLink to={links.runbookSnapshotPage.generateUrl({
                        spaceId: this.props.runbook.SpaceId,
                        projectSlug: this.props.project.Slug,
                        runbookId: this.state.publishedRunbookSnapshot.RunbookId,
                        runbookSnapshotId: this.state.publishedRunbookSnapshot.Id,
                    })} openInSelf={false}>
                                                <Tooltip content={<RunbookSnapshotInformation runbookSnapshot={this.state.publishedRunbookSnapshot}/>}>{this.state.publishedRunbookSnapshot.Name}</Tooltip>
                                            </InternalLink>
                                            .
                                        </Note>
                                        <RadioButton disabled={this.isCurrentDraftDisabled()} value={RunType.CreateNew} label="Current draft (with unpublished changes)"/>
                                        <Note>This will create a new snapshot based on the current process and variables.</Note>
                                        {this.renderGitRepoErrorCallout()}
                                    </RadioButtonGroup>
                                </ExpandableFormSection>
                            </PermissionCheck>)}
                        {!this.existingRunbookSnapshotId && hasEditingPackages && (<ExpandableFormSection errorKey="packages" title="Packages" fillCardWidth={CardFill.FillAll} summary={this.packagesSummary()} help={"Select package(s) for this snapshot"}>
                                <div className={styles.packageTableContainer}>
                                    <LegacyDataTable className={styles.packageTable}>
                                        <LegacyDataTableHeader>
                                            <LegacyDataTableRow>
                                                <LegacyDataTableHeaderColumn>
                                                    <div className={styles.actionName}>Step</div>
                                                    Package
                                                </LegacyDataTableHeaderColumn>
                                                <LegacyDataTableHeaderColumn>
                                                    <Tooltip key="latest" content="The most recent package that we could find in the package feed">
                                                        <ExternalLink href="LatestPackage">Latest</ExternalLink>
                                                        {this.state.model.editingPackages && this.state.model.editingPackages.length > 1 && (<React.Fragment>
                                                                <br />
                                                                <Note>
                                                                    <a href="#" onClick={(e) => this.setAllPackageVersionsTo(e, VersionType.latest, null!, false)}>
                                                                        Select all
                                                                    </a>
                                                                </Note>
                                                            </React.Fragment>)}
                                                    </Tooltip>
                                                </LegacyDataTableHeaderColumn>
                                                <LegacyDataTableHeaderColumn>Specific</LegacyDataTableHeaderColumn>
                                            </LegacyDataTableRow>
                                        </LegacyDataTableHeader>
                                        <LegacyDataTableBody>
                                            {this.state.model && this.state.model.editingPackages && (<LoadMoreWrapper items={this.state.model.editingPackages} renderLoadMore={(children) => {
                            return (<LegacyDataTableRow>
                                                                <LegacyDataTableRowColumn colSpan={4}>{children}</LegacyDataTableRowColumn>
                                                            </LegacyDataTableRow>);
                        }} renderItem={(pack, index) => (<LegacyDataTableRow key={this.createPackageKey(pack)}>
                                                            <LegacyDataTableRowColumn className={cn(styles.packageTableRowColumn, styles.packageColumn)}>
                                                                <div className={styles.actionName}>
                                                                    {pack.ActionName}
                                                                    {!!pack.PackageReferenceName && <span>/{pack.PackageReferenceName}</span>}
                                                                </div>
                                                                <Tooltip key="packageId" content={pack.ProjectName ? pack.ProjectName : pack.PackageId + " from " + pack.FeedName}>
                                                                    {pack.ProjectName ? pack.ProjectName : pack.PackageId}
                                                                </Tooltip>
                                                            </LegacyDataTableRowColumn>
                                                            <LegacyDataTableRowColumn className={cn(styles.packageTableRowColumn, styles.latestColumn)}>
                                                                {this.buildRadioButton(pack, pack.LatestVersion, VersionType.latest, this.state.model)}
                                                            </LegacyDataTableRowColumn>
                                                            <LegacyDataTableRowColumn className={cn(styles.packageTableRowColumn, styles.specificColumn)}>
                                                                <div className={styles.specificVersionDiv}>
                                                                    {pack.FixedVersion ? (<Tooltip content={`The version for this package is set in the Runbook process.`}>
                                                                            <div className={styles.inlineDiv}>{this.buildRadioButton(pack, pack.FixedVersion, VersionType.specific, this.state.model!)}</div>
                                                                        </Tooltip>) : (<>
                                                                            <div className={styles.inlineDiv}>{this.buildRadioButton(pack, pack.SpecificVersion, VersionType.specific, this.state.model!)}</div>
                                                                            <div className={styles.inlineDiv}>
                                                                                <div className={styles.editVersionArea}>
                                                                                    <DebounceText debounceDelay={500} className={styles.versionTextbox} placeholder="Enter a version" accessibleName="Specific version" value={pack.FixedVersion ? pack.FixedVersion : pack.SpecificVersion} onChange={async (version) => {
                                    await this.specificVersionSelected(this.state.model!, pack, version);
                                }} disabled={!!pack.FixedVersion}/>
                                                                                </div>
                                                                            </div>
                                                                            <div className={styles.inlineDiv}>{this.packageVersionsButton(pack)}</div>
                                                                        </>)}
                                                                </div>
                                                            </LegacyDataTableRowColumn>
                                                        </LegacyDataTableRow>)}/>)}
                                        </LegacyDataTableBody>
                                    </LegacyDataTable>
                                </div>
                            </ExpandableFormSection>)}
                        {!!this.existingRunbookSnapshotId && hasEditingPackages && (<ExpandableFormSection errorKey="packages" title="Packages" summary={this.packagesSummary()} help={"You cannot modify an existing snapshot's packages"}>
                                <PermissionCheck permission={Permission.FeedView} alternate={<Callout type={"information"} title={"Permission required"}>
                                            The {Permission.FeedView} permission is required to view packages
                                        </Callout>}>
                                    <PermissionCheck permission={Permission.RunbookView} project={this.state.model.runbookSnapshot.ProjectId} wildcard={true} alternate={<Callout type={"information"} title={"Permission required"}>
                                                The {Permission.RunbookView} permission is required to view packages
                                            </Callout>}>
                                        <div className={styles.releasePackagesLayout}>
                                            <PackagesList packages={this.state.model.readonlyPackages} buildInformation={null}/>
                                        </div>
                                    </PermissionCheck>
                                </PermissionCheck>
                            </ExpandableFormSection>)}
                        {!this.existingRunbookSnapshotId && hasEditingGitResources && (<GitResourcesSection project={this.props.project} context={"Runbook"} showLastGitResource={true} runbookId={this.state.model.runbookSnapshot.RunbookId} runbookSnapshotId={this.state.model.runbookSnapshot.Id} gitResources={this.state.model.editingGitResources} onUpdateGitRef={(gitRef: GitReferenceEditInfo) => {
                        this.setState((prevState) => {
                            const updatedGitRefs = prevState.model?.editingGitResources.map((gr) => (gr.ActionName === gitRef.ActionName ? gitRef : gr));
                            return {
                                model: {
                                    ...prevState.model,
                                    gitResources: updatedGitRefs,
                                },
                            };
                        });
                    }}/>)}
                        {!!this.existingRunbookSnapshotId && hasEditingGitResources && (<ExpandableFormSection errorKey="gitResources" title="Git Resources" summary={this.gitResourcesSummary()} help={"You cannot modify an existing snapshot's git resources"}>
                                <PermissionCheck permission={Permission.RunbookView} project={this.state.model.runbookSnapshot.ProjectId} wildcard={true} alternate={<Callout type={"information"} title={"Permission required"}>
                                            The {Permission.RunbookView} permission is required to view git resources
                                        </Callout>}>
                                    <div className={styles.releasePackagesLayout}>
                                        <GitResourcesList gitReferences={this.state.model.readonlyGitResources}/>
                                    </div>
                                </PermissionCheck>
                            </ExpandableFormSection>)}
                        <ExpandableFormSection errorKey="AdvancedOptions" title="" isExpandedByDefault={false} expandable={false} summary={Summary.summary(<ActionButton type={ActionButtonType.Secondary} label={`${this.state.showAdvanced ? "Hide" : "Show"} advanced`} onClick={() => this.setState({ showAdvanced: !this.state.showAdvanced })}/>)} help="Advanced options." useCardTitleContainerStyleForSummary={true}/>
                        <Collapse in={this.state.showAdvanced} timeout="auto" unmountOnExit={true}>
                            {!this.state.isGitRunbook && (<>
                                    <ExpandableFormSection errorKey="Name" title="Name" focusOnExpandAll isExpandedByDefault={false} summary={this.state.model.runbookSnapshot.Name ? Summary.summary(this.state.model.runbookSnapshot.Name) : Summary.placeholder("Please enter a name")} help={!!this.existingRunbookSnapshotId ? "You cannot modify an existing snapshot's name" : "Add a name for your runbook"}>
                                        <Text value={this.state.model.runbookSnapshot.Name} onChange={(Name) => {
                        const runbookSnapshot = this.state.model.runbookSnapshot;
                        runbookSnapshot.Name = Name;
                        const model = this.state.model;
                        model.runbookSnapshot = runbookSnapshot;
                        this.setState({ model });
                    }} label="Name" validate={required("Please enter a name")} error={this.getFieldError("Name")} disabled={!!this.existingRunbookSnapshotId}/>
                                    </ExpandableFormSection>

                                    <ExpandableFormSection errorKey="Notes" title="Notes" isExpandedByDefault={false} summary={this.state.model.runbookSnapshot.Notes ? Summary.summary(this.state.model.runbookSnapshot.Notes) : Summary.placeholder("No notes included")} help={!!this.existingRunbookSnapshotId ? "You cannot modify an existing snapshot's notes" : "Include notes for your runbook"}>
                                        <Text value={this.state.model.runbookSnapshot.Notes} onChange={(Notes) => {
                        const runbookSnapshot = this.state.model.runbookSnapshot;
                        runbookSnapshot.Notes = Notes;
                        const model = this.state.model;
                        model.runbookSnapshot = runbookSnapshot;
                        this.setState({ model });
                    }} label="Notes" error={this.getFieldError("Notes")} disabled={!!this.existingRunbookSnapshotId}/>
                                    </ExpandableFormSection>
                                </>)}

                            <NowOrLater onScheduleDatesSet={this.onDeploymentScheduleChanged} modelType={DeploymentModelType.Runbook}/>

                            <ActionToggle repository={this.props.projectContextState.projectContextRepository} selectedEnvironmentIds={getEnvironmentIds(this.state.selectedEnvironments)} previews={Array.from(this.state.previews.values())} release={this.state.model.runbookSnapshot} actionIds={this.state.actionIdsToSkip} onActionIdsChanged={this.onActionIdsToSkipChanged} project={this.props.project} gitRef={this.state.isGitRunbook ? this.props.gitRef : undefined} warnWhenSkippingStepsThatAffectLiveStatus={false}/>

                            <FailureMode defaultGuidedFailureMode={this.state.defaultGuidedFailureMode} guidedFailureMode={this.state.guidedFailureMode} onModeChanged={(guidedFailureMode) => this.setState({ guidedFailureMode })} modelType={DeploymentModelType.Runbook}/>

                            <PackageDownloadOptions forcePackageDownload={this.state.forcePackageDownload} onOptionChanged={this.onPackageDownloadOptionChanged}/>

                            <DebugOptions onChange={this.onDebugOptionChanged} debugMode={this.state.debugMode}/>

                            <FailTargetDiscoveryOptions defaultFailTargetDiscovery={false} failTargetDiscovery={this.state.failTargetDiscovery} onOptionChanged={this.onFailTargetDiscoveryOptionChanged} modelType={DeploymentModelType.Runbook}/>

                            <PriorityOptions priority={this.state.priority} context={"runbook"} onChange={this.onPriorityChanged}/>

                            {projectChangeRequestSettings &&
                    this.state.selectedEnvironments.length > 0 &&
                    projectChangeRequestSettings.map((s) => s && (<ItsmChangeRequestSettings key={s.ExtensionId} context={s} changeRequestSettings={this.state.changeRequestSettings?.filter((crs) => crs.Type === this.getChangeRequestTypeFromExtensionId(s))[0]} onChangeRequestSettingsChanged={this.onChangeRequestSettingsChanged}/>))}

                            {this.state.runbookRunRequests.length > 0 && (<DeploymentPreview release={this.state.model.runbookSnapshot} getDeploymentPreview={this.getDeploymentPreview} deployments={this.state.runbookRunRequests} stepActionIdsToSkip={this.state.actionIdsToSkip} tenantedDeploymentMode={this.props.runbook.MultiTenancyMode} promptVariableForm={this.state.promptVariablesForm} onExcludeSpecificMachinesSelected={this.onExcludeSpecificMachinesSelected} onIncludeSpecificMachinesSelected={this.onIncludeSpecificMachinesSelected} onAllTargetsSelected={this.onAllTargetsSelected} tenantsWithMissingVariables={tenantsWithMissingVariables} onDoingBusyTask={this.doBusyTask} allTenants={this.state.allTenants.filter((t) => !t.IsDisabled)} modelType={DeploymentModelType.Runbook} isExpandedByDefault={this.props.runbook.MultiTenancyMode === TenantedDeploymentMode.Untenanted}/>)}
                        </Collapse>
                    </div>)}
            </div>);
    }
    private getChangeRequestTypeFromExtensionId(extension: ServiceNowProjectSettings | JiraServiceManagementProjectSettings): ChangeRequestSettingsType {
        switch (extension.ExtensionId) {
            case "servicenow-integration":
                return ChangeRequestSettingsType.ServiceNow;
            case "jiraservicemanagement-integration":
                return ChangeRequestSettingsType.JiraServiceManagement;
            default:
                throw new Error("unknown extension id");
        }
    }
    private buildRadioButton(pack: PackageEditInfo, version: string, type: VersionType, model: RunbookRunNowLayoutModel) {
        if (!pack.IsResolvable && type === VersionType.latest) {
            return <div />;
        }
        return (<RadioButtonGroup className={styles.radioButtonContainer} value={type} onChange={(item) => {
                this.packageVersionChanged(model, pack, version, type);
            }}>
                <RadioButton className={styles.myRadioButton} value={pack.FixedVersion ? VersionType.specific : pack.VersionType} label={type === VersionType.specific && !pack.FixedVersion ? "" : version} disabled={!!pack.FixedVersion && type !== VersionType.specific}/>
            </RadioButtonGroup>);
    }
    private packageVersionsButton = (pkg: PackageEditInfo) => {
        const feed = this.state.feeds ? this.state.feeds[pkg.FeedId] : undefined;
        const openDialog = (disabled: boolean) => {
            if (!feed) {
                throw Error(`The provided feed ${pkg.FeedId} could not be found`);
            }
            return (<OpenDialogButton type={ActionButtonType.Secondary} dialogWidth={"1000px"} disabled={disabled} label="Select Version">
                    <PackageListDialogContent package={pkg} feed={feed} onVersionSelected={(version) => {
                    this.specificVersionSelected(this.state.model, pkg, version);
                }} channelFilters={{}}/>
                </OpenDialogButton>);
        };
        if (feed) {
            return openDialog(false);
        }
        return <Tooltip content="No feed available. Package step may be using a variable as feed.">{openDialog(true)}</Tooltip>;
    };
    private specificVersionSelected = (model: RunbookRunNowLayoutModel, pack: PackageEditInfo, version: string) => {
        pack.SpecificVersion = version;
        this.packageVersionChanged(model, pack, version, VersionType.specific);
    };
    private setAllPackageVersionsTo = (e: React.MouseEvent, versionType: VersionType, specificVersion: string, includeConfirmation: boolean) => {
        e.preventDefault();
        if (includeConfirmation && !confirm(`This will set all packages to version ${specificVersion}. Are you sure this version exists for all the packages?`)) {
            return;
        }
        const model = this.state.model;
        const runbookSnapshot = model.runbookSnapshot;
        runbookSnapshot.SelectedPackages = [];
        for (const selection of this.state.model.editingPackages) {
            selection.VersionType = selection.FixedVersion ? VersionType.specific : versionType;
            selection.SpecificVersion = specificVersion;
            runbookSnapshot.SelectedPackages.push({
                ActionName: selection.ActionName,
                Version: specificVersion,
                PackageReferenceName: selection.PackageReferenceName,
            });
        }
        this.setState({ model });
    };
    private onChangeRunType = async (runType: RunType) => {
        // Workaround to ensure we trigger the reload after we change the run type.
        await this.setStateAsync({ ...this.state, runType });
        await this.reload();
        // Reload previews to determine whether prompt variable form is needed
        const environments = this.state.selectedEnvironments;
        const tenantIds = this.state.selectedTenantIds;
        const previews = await this.loadRunbookRunPreviews(environments.map((e) => e.environmentId), tenantIds);
        this.setState({
            previews,
            promptVariablesForm: this.loadFormDetails(previews),
        });
    };
    private snapshotSummary = () => {
        return Summary.summary(`Using ${this.state.runType} snapshot`);
    };
    private packagesSummary = () => {
        if (!this.state.model.editingPackages || this.state.model.editingPackages.length === 0) {
            return Summary.placeholder("No package is included");
        }
        const packageVersions = this.state.model.editingPackages.map((p) => this.getPackageInfoVersion(p));
        if (packageVersions.length === 1) {
            return Summary.summary(packageVersions[0] ? ("1 package included, at version " + packageVersions[0]) : (<span>
                        1 package included, <strong>no version specified</strong>
                    </span>));
        }
        const firstVersion = packageVersions.find((p) => !!p);
        const noneHaveVersion = !firstVersion;
        const allOnSameVersion = firstVersion && packageVersions.every((p) => p === firstVersion);
        const numberWithNoVersion = packageVersions.filter((p) => !p).length;
        const packagesIncluded = packageVersions.length + " packages included";
        const noVersionSummary = numberWithNoVersion ? (<span>
                ,{" "}
                <strong>
                    {numberWithNoVersion} {numberWithNoVersion === 1 ? "has" : "have"} no version selected
                </strong>
            </span>) : (<span />);
        const versionSummary = allOnSameVersion ? ", all at version " + firstVersion : noneHaveVersion ? "" : ", with a mix of versions";
        return Summary.summary(<span>
                {packagesIncluded}
                {versionSummary}
                {noVersionSummary}
            </span>);
    };
    private getPackageInfoVersion(info: PackageEditInfo): string {
        if (info.FixedVersion) {
            return info.FixedVersion;
        }
        return info.VersionType === VersionType.specific ? info.SpecificVersion : info.LatestVersion;
    }
    private getDeploymentPreview = (environmentId: string, tenantId: string) => {
        return this.state.previews.get(`${environmentId || ""}${tenantId || ""}`)!;
    };
    private publishedSnapshotExists() {
        const runbook = this.props.runbook;
        return runbook.PublishedRunbookSnapshotId && !this.props.runbookSnapshotId;
    }
    private isCurrentDraftDisabled = () => {
        return this.state.gitRepoErrors.length > 0;
    };
    private isThereNothingToRun = () => {
        // If the current draft can't be run and there is no published snapshot, there is nothing to run.
        return !this.publishedSnapshotExists() && this.isCurrentDraftDisabled();
    };
    private checkCanDeploy(selectedEnvironments: EnvironmentSelection[], resultantTenants: string[]): boolean {
        if (this.isThereNothingToRun()) {
            return false;
        }
        const environmentSelected = selectedEnvironments.length > 0;
        const tenantSelected = resultantTenants && resultantTenants.length > 0;
        switch (this.props.runbook.MultiTenancyMode) {
            case TenantedDeploymentMode.TenantedOrUntenanted:
                return environmentSelected || tenantSelected;
            case TenantedDeploymentMode.Untenanted:
                return environmentSelected && !tenantSelected;
            case TenantedDeploymentMode.Tenanted:
                return environmentSelected && (tenantSelected || this.state.selectedEnvironments.every((e) => e.type === "Ephemeral")); // Can run on ephemeral environments without tenants even if tenanted runs are required
            default:
                throw new Error("TenantedDeploymentMode not recognized");
        }
    }
    private buildPromotionsMap(template: RunbookRunTemplateResource) {
        const promotionsMap: PromotionsMap = {};
        _.each(template.PromoteTo, (environmentPromotion) => {
            promotionsMap[environmentPromotion.Id] = environmentPromotion;
        });
        _.each(template.TenantPromotions, (tenantPromotion) => {
            promotionsMap[tenantPromotion.Id] = tenantPromotion;
        });
        return promotionsMap;
    }
    private async loadMissingTenantVariables(project: ProjectResource, runbook: RunbookResource): Promise<Dictionary<string[]>> {
        if (runbook.MultiTenancyMode === TenantedDeploymentMode.Untenanted) {
            return Promise.resolve({});
        }
        const missingTenantVariables = await repository.Tenants.missingVariables({ projectId: project.Id }, true);
        const missingVariables: Dictionary<string[]> = {};
        missingTenantVariables.forEach((t) => {
            t.MissingVariables.forEach((mv) => {
                const newVals = missingVariables[mv.EnvironmentId!] || [];
                newVals.push(t.TenantId);
                missingVariables[mv.EnvironmentId!] = _.uniq(newVals);
            });
        });
        return missingVariables;
    }
    private getPackagesAndGitResources(model: RunbookRunNowLayoutModel): [
        SelectedPackage[],
        SelectedGitResource[]
    ] {
        const selectedPackages = [];
        for (const selection of model.editingPackages) {
            let selectedVersion = "";
            if (selection.FixedVersion) {
                selectedVersion = selection.FixedVersion;
            }
            else if (selection.VersionType === VersionType.latest) {
                selectedVersion = selection.LatestVersion;
            }
            else if (selection.VersionType === VersionType.last) {
                selectedVersion = selection.LastReleaseVersion;
            }
            else if (selection.VersionType === VersionType.specific) {
                selectedVersion = selection.SpecificVersion;
            }
            selectedPackages.push({
                ActionName: selection.ActionName,
                Version: selectedVersion,
                PackageReferenceName: selection.PackageReferenceName,
            });
        }
        const selectedGitResources = [];
        for (const selection of model.editingGitResources) {
            let selectedGitReference: GitReference | undefined;
            if (selection.GitReferenceType === GitReferenceType.last) {
                selectedGitReference = selection.LastGitResource;
            }
            else if (selection.GitReferenceType === GitReferenceType.specific) {
                selectedGitReference = selection.SpecificGitResource;
            }
            if (selectedGitReference) {
                selectedGitResources.push({
                    ActionName: selection.ActionName,
                    GitReferenceResource: selectedGitReference,
                    GitResourceReferenceName: selection.GitResourceReferenceName ?? "",
                });
            }
        }
        return [selectedPackages, selectedGitResources];
    }
    private async saveRunbookSnapshot(): Promise<void> {
        const model = this.state.model;
        const runbookSnapshot = model.runbookSnapshot;
        if (runbookSnapshot.Id) {
            logger.error("Cannot save/modify an existing snapshot. This should not happen.", { runbookSnapshot });
            return;
        }
        await this.doBusyTask(async () => {
            const [selectedPackages, selectedGitResources] = this.getPackagesAndGitResources(model);
            runbookSnapshot.SelectedPackages = selectedPackages;
            runbookSnapshot.SelectedGitResources = selectedGitResources;
            const newRunbookSnapshot = await repository.RunbookSnapshots.create(runbookSnapshot);
            const newModel = this.buildModel(newRunbookSnapshot, model.editingPackages, model.readonlyPackages, model.editingGitResources, model.readonlyGitResources);
            await this.setStateAsync({
                ...this.state,
                model: newModel,
                cleanModel: cloneDeep(newModel),
            });
        });
    }
    private async runGitRunbook() {
        // This page was initially built for creating runbook runs for database Runbooks, where
        // the snapshot and runs were created separately. These request objects are built up as
        // the user edits on the page, and then sent when the user clicks "Run now".
        //
        // For Git Runbooks, the snapshots and runs are all created in a single request, so it's a
        // different shape to the requests that are alreaady built up. This method translates the
        // requests into the shape we need for a Git Runbook and sends them off.
        if (!this.props.gitRef) {
            throw new Error("Cannot run Git Runbook. There is no Git reference selected.");
        }
        const gitRef = this.props.gitRef;
        const [selectedPackages, selectedGitResources] = this.getPackagesAndGitResources(this.state.model);
        const runCommand: RunGitRunbookCommand = {
            SelectedPackages: selectedPackages,
            SelectedGitResources: selectedGitResources,
            Notes: this.state.model.runbookSnapshot.Notes,
            Runs: [],
        };
        const variables = this.state.promptVariablesForm ? this.state.promptVariablesForm.Values : undefined;
        await this.setUseGuidedFailure(this.state.runbookRunRequests);
        for (const run of this.state.runbookRunRequests) {
            runCommand.Runs.push({
                EnvironmentId: run.request.EnvironmentId,
                TenantId: run.request.TenantId,
                ForcePackageDownload: run.request.ForcePackageDownload,
                DebugMode: run.request.DebugMode,
                SkipActions: run.request.SkipActions,
                SpecificMachineIds: run.request.SpecificMachineIds,
                ExcludedMachineIds: run.request.ExcludedMachineIds,
                UseGuidedFailure: run.request.UseGuidedFailure,
                FormValues: variables,
                QueueTime: run.request.QueueTime,
                QueueTimeExpiry: run.request.QueueTimeExpiry,
            });
        }
        await this.doBusyTask(async () => {
            this.setState({ numOfRunbookRunsToBeCreated: runCommand.Runs.length });
            let response;
            try {
                response = await repository.Runbooks.runGitRunbook(this.props.project, this.props.runbook.Id, gitRef, runCommand);
            }
            finally {
                this.setState({ numOfRunbookRunsToBeCreated: null, numOfRunbookRunsCreated: 0 }); // Reset number of runbook runs to close dialog
            }
            if (response.Resources.length > 1) {
                // If we ran multiple Runbooks, go to the task list page filtered to show the created Runbook tasks.
                const taskIds = response.Resources.map((run) => run.TaskId);
                this.setState({ redirectPath: links.tasksPage.generateUrl({ ids: taskIds, spaces: [repository.spaceId!], includeSystem: false }) });
            }
            else {
                // If we ran a single Runbook, go to the task details page for that Runbook.
                const run = response.Resources[0];
                const redirectPath = links.runbookRunPage.generateUrl({
                    spaceId: this.props.project.SpaceId,
                    projectSlug: this.props.project.Slug,
                    runbookId: run.RunbookId,
                    runbookSnapshotId: run.RunbookSnapshotId,
                    runbookRunId: run.Id,
                });
                this.setState({ redirectPath });
            }
        });
    }
    private async onRunNowClicked(retry = false) {
        if (this.state.isGitRunbook) {
            return this.runGitRunbook();
        }
        // For new runs, create the single snapshot for all of them.
        if (!this.state.model.runbookSnapshot.Id) {
            await this.saveRunbookSnapshot();
            if (this.errors) {
                return;
            }
        }
        await this.doBusyTask(async () => {
            // Inject our newly-created snapshot into our requests.
            const disabledTenantIds = this.state.allTenants.filter((t) => t.IsDisabled).map((t) => t.Id);
            const runbookRunRequests = this.state.runbookRunRequests.filter((runbookRun) => {
                return !runbookRun.tenantId || !disabledTenantIds.includes(runbookRun.tenantId);
            });
            for (const runbookRun of runbookRunRequests) {
                const runbookRunRequest = runbookRun.request as CreateRunbookRunRequestResource;
                runbookRunRequest.RunbookSnapshotId = this.state.model.runbookSnapshot.Id;
            }
            await this.setStateAsync({ ...this.state, runbookRunRequests });
            const runbookRunsBeingCreated = retry ? this.state.runbookRunRequests.filter((r) => r.response && this.isError(r.response)).length : this.state.runbookRunRequests.length;
            this.setState({ numOfRunbookRunsToBeCreated: runbookRunsBeingCreated });
            // Create runs.
            const runbookRunPromises = [];
            const runbookRuns = _.cloneDeep(this.state.runbookRunRequests);
            const errors: Errors[] = [];
            await this.setUseGuidedFailure(runbookRuns);
            this.setChangeRequestSettings(runbookRuns);
            //Fire off a max of 10 runs requests at any one time, so we don't bombard the server if there are many environments/tenants
            const throttle = PLimit.default(10);
            for (const record of runbookRuns) {
                // If retrying, only process previously failed
                if (retry) {
                    if (!record.response || !this.isError(record.response)) {
                        continue;
                    }
                }
                record.request.FormValues = this.state.promptVariablesForm ? this.state.promptVariablesForm.Values : null;
                runbookRunPromises.push(throttle(() => repository.RunbookRuns.create(record.request as any)
                    .then((runbookRun) => {
                    record.response = runbookRun;
                    this.setState({ numOfRunbookRunsCreated: this.state.numOfRunbookRunsCreated + 1 });
                })
                    .catch((ex) => {
                    const error = createErrorsFromOctopusError(ex);
                    const arbitraryErrors = error.errors.reduce((prev, current, index) => ({
                        ...prev,
                        [`error_${index}`]: current,
                    }), {});
                    const key = record.tenantId ? record.tenantId : record.environment.environmentId;
                    const text = record.tenantId ? this.state.allTenants.find((t) => t.Id === record.tenantId)?.Name || record.tenantId : record.environment.name;
                    error.details = { [key]: text };
                    error.fieldErrors = { ...arbitraryErrors, ...matchErrorsToFieldNames(ex, this.state.model) };
                    errors.push(error);
                    record.response = ex;
                })));
            }
            await Promise.all(runbookRunPromises);
            // Reset number of runbook runs to close dialog
            this.setState({ numOfRunbookRunsToBeCreated: null, numOfRunbookRunsCreated: 0 });
            this.redirectToRunPage(runbookRuns, errors);
        });
    }
    private redirectToRunPage(runbookRuns: DeploymentRequestModel[], errors: Errors[]) {
        const runbookRunResult = runbookRuns[0].response as RunbookRunResource;
        if (runbookRuns.length === 1 && runbookRunResult.TaskId) {
            // If creating a single runbookRun was successful, navigate to the task details for that runbookRun.
            const redirectPath = links.runbookRunPage.generateUrl({
                spaceId: this.props.project.SpaceId,
                projectSlug: this.props.project.Slug,
                runbookId: runbookRunResult.RunbookId,
                runbookSnapshotId: runbookRunResult.RunbookSnapshotId,
                runbookRunId: runbookRunResult.Id,
            });
            this.setState({ redirectPath });
        }
        else if (_.every(runbookRuns, (result) => !!(result.response as RunbookRunResource).TaskId)) {
            // If creating multiple runbookRuns were all successful, navigate to the task list page filtered
            // to show the created runbookRun tasks
            const taskIds = _.map(runbookRuns, (result) => (result.response as RunbookRunResource).TaskId);
            this.setState({ redirectPath: links.tasksPage.generateUrl({ ids: taskIds, spaces: [repository.spaceId!], includeSystem: false }) });
        }
        else {
            // Otherwise there was at least one error when creating the runbookRun/s
            if (runbookRuns.length > 1 && errors.length > 1) {
                const octopusError = new OctopusError(400, `${errors.length}/${runbookRuns.length} errors occurred while attempting to create runbook runs.`);
                octopusError.Errors = errors.map((e) => `Error creating runbook in ${e.details && Object.values(e.details)[0]}`);
                this.setState({ ...this.state, showAdvanced: true });
                this.setOctopusErrors(octopusError);
            }
            else if (errors.length === 1) {
                this.setValidationErrors(errors[0].message, errors[0].fieldErrors);
                // If there was a single error then the error details at the top of the page
            }
            else {
                // If there were multiple errors, show a generic message at the top of the page
                // The individual error details will be shown in the runbookRuns section
                this.setValidationErrors(`${errors.length} errors occurred while attempting to create the runbookRuns.`);
            }
            this.setState({ runbookRunRequests: runbookRuns });
        }
    }
    private createRunbookRunsForEnvironments(environments: EnvironmentSelection[], tenantIds: string[], promptVariablesForm: PromptVariablesForm) {
        const results = [];
        if (environments.length === 0) {
            return [];
        }
        if (tenantIds.length > 0) {
            for (const tenantId of tenantIds) {
                results.push(this.createRunbookRunRequestForEnvironment(environments[0], tenantId, promptVariablesForm));
            }
        }
        else {
            // Can run a runbook without a tenant if it's not in tenanted mode or if we're running on only ephemeral environments
            if (this.props.runbook && (this.props.runbook.MultiTenancyMode !== TenantedDeploymentMode.Tenanted || environments.every((e) => e.type === "Ephemeral"))) {
                for (const environment of environments) {
                    results.push(this.createRunbookRunRequestForEnvironment(environment, null!, promptVariablesForm));
                }
            }
        }
        return results;
    }
    private async loadRunbookRunPreviews(environmentIds: string[], tenantIds: string[]) {
        const map = new Map<string, RunbookRunPreviewResource>();
        let keys: string[] = [];
        let values: RunbookRunPreviewResource[] = [];
        // If tenants have been selected then we use the tenant-environment runbookRun-previews
        if (tenantIds && tenantIds.length > 0) {
            [keys, values] = await this.getTenantEnvironmentPreviews(environmentIds, tenantIds);
        }
        else {
            const promises = environmentIds
                .filter((environmentId) => this.state.promotionsMap[environmentId])
                .map((environmentId) => {
                keys.push(environmentId);
                if (this.existingRunbookSnapshotId) {
                    // No GitRef for snapshot preview - we don't run snapshots directly for Git Runbooks
                    return repository.Runbooks.getRunbookRunSnapshotPreview(this.props.project, this.existingRunbookSnapshotId, environmentId);
                }
                else {
                    const gitRef = this.state.isGitRunbook ? this.props.gitRef : undefined;
                    return repository.Runbooks.getRunbookRunPreview(this.props.project, this.props.runbook.Id, environmentId, gitRef);
                }
            });
            values = await Promise.all(promises);
        }
        for (let index = 0; index < keys.length; index++) {
            map.set(keys[index], values[index]);
        }
        return map;
    }
    // Returns promises for runbookRun-previews for the combination of selected tenants and environments
    private async getTenantEnvironmentPreviews(environmentIds: string[], tenantIds: string[]): Promise<[
        string[],
        RunbookRunPreviewResource[]
    ]> {
        const keys: string[] = [];
        const requestedRunbookRunPreviews = _.flatten(tenantIds.map((tenantId) => {
            const dpt = this.state.promotionsMap[tenantId] as DeploymentPromotionTenant;
            return dpt.PromoteTo.filter((tenantEnvironmentPromotion) => environmentIds.includes(tenantEnvironmentPromotion.Id)).map((tenantEnvironmentPromotion) => {
                keys.push(tenantEnvironmentPromotion.Id + tenantId);
                return { TenantId: tenantId, EnvironmentId: tenantEnvironmentPromotion.Id };
            });
        }));
        const request = { DeploymentPreviews: requestedRunbookRunPreviews };
        const values = await repository.Runbooks.runbookRunTenantPreviews(this.props.project, this.props.runbook.Id, request, this.state.isGitRunbook ? this.props.gitRef : undefined);
        return [keys, values];
    }
    private loadFormDetails(previews: Map<string, RunbookRunPreviewResource>) {
        const form: PromptVariablesForm = { Elements: [], Values: {} };
        previews.forEach((preview: RunbookRunPreviewResource) => {
            if (!preview || !preview.Form) {
                return;
            }
            if (preview.Form.Values) {
                _.each(preview.Form.Values, (v, k) => {
                    form.Values[k] = v;
                });
            }
            if (preview.Form.Elements) {
                preview.Form.Elements.forEach((c) => {
                    if (!form.Elements.find((e: FormElement) => e.Name === c.Name)) {
                        form.Elements.push(c);
                    }
                });
            }
        });
        return form;
    }
    private createRunbookRunRequestForEnvironment(environment: EnvironmentSelection, tenantId: string, promptVariablesForm: PromptVariablesForm): DeploymentRequestModel {
        const isRetryingInThisScope = this.state.previousRunbookRunBeingRetried && this.state.previousRunbookRunBeingRetried.EnvironmentId === environment.environmentId && this.state.previousRunbookRunBeingRetried.TenantId === tenantId;
        const specificMachineIds = isRetryingInThisScope && this.state.previousRunbookRunBeingRetried!.SpecificMachineIds.length > 0 ? this.state.previousRunbookRunBeingRetried!.SpecificMachineIds : [];
        const excludeMachineIds = isRetryingInThisScope && this.state.previousRunbookRunBeingRetried!.ExcludedMachineIds.length > 0 ? this.state.previousRunbookRunBeingRetried!.ExcludedMachineIds : [];
        const model = this.state.model;
        const runbookSnapshot = model.runbookSnapshot;
        runbookSnapshot.SelectedPackages = [];
        for (const selection of this.state.model.editingPackages) {
            let selectedVersion = "";
            if (selection.VersionType === VersionType.latest) {
                selectedVersion = selection.LatestVersion;
            }
            else if (selection.VersionType === VersionType.last) {
                selectedVersion = selection.LastReleaseVersion;
            }
            else if (selection.VersionType === VersionType.specific) {
                selectedVersion = selection.SpecificVersion;
            }
            runbookSnapshot.SelectedPackages.push({
                ActionName: selection.ActionName,
                Version: selectedVersion,
                PackageReferenceName: selection.PackageReferenceName,
            });
        }
        const request: CreateRunbookRunRequestResource = {
            RunbookId: this.props.runbook.Id,
            RunbookSnapshotId: runbookSnapshot.Id,
            FrozenRunbookProcessId: null!,
            EnvironmentId: environment.environmentId,
            ProjectId: this.props.project.Id,
            TenantId: tenantId,
            SkipActions: this.state.actionIdsToSkip,
            QueueTime: this.state.queueTime,
            QueueTimeExpiry: this.state.queueTimeExpiry,
            FormValues: promptVariablesForm ? promptVariablesForm.Values : null,
            ForcePackageDownload: this.state.forcePackageDownload,
            DebugMode: this.state.debugMode,
            ForcePackageRedeployment: true,
            FailTargetDiscovery: this.state.failTargetDiscovery,
            UseGuidedFailure: false,
            Priority: this.state.priority,
            SpecificMachineIds: specificMachineIds,
            ExcludedMachineIds: excludeMachineIds,
        };
        return {
            tenantId,
            environment,
            request,
            currentVersion: this.state.currentVersionMap && this.state.currentVersionMap.getCurrentRelease(environment.environmentId, tenantId)!,
        };
    }
    private onSelectionUpdated = async (environments: EnvironmentSelection[], tenantIds: string[], tenantTagsUsed: boolean) => {
        const previews = new Map<string, RunbookRunPreviewResource>();
        const runbookRunRequests: DeploymentRequestModel[] = [];
        const environmentIds = getEnvironmentIds(environments);
        let isStaleResponse = false;
        await this.doBusyTask(async () => {
            if (environments.length > 0) {
                await this.runRaceConditioner.avoidStaleResponsesForRequest(this.getAvailableRunsFromApi(environments, tenantIds, tenantTagsUsed), async (apiResults) => {
                    if (apiResults.allowRun) {
                        apiResults.previews.forEach((preview, key) => {
                            previews.set(key, preview);
                        });
                        runbookRunRequests.push(...apiResults.requests);
                    }
                }, () => {
                    isStaleResponse = true;
                });
            }
            if (!isStaleResponse) {
                let pendingInterruptions: Array<TaskResource<any>> = [];
                // We only load interruptions if the number of deployments is low, see https://github.com/OctopusDeploy/Issues/issues/4415
                if (runbookRunRequests.length < MaximumInterruptionsToLoad) {
                    pendingInterruptions = await loadPendingInterruptions(this.props.project.Id, runbookRunRequests.map((d) => {
                        return { EnvironmentId: d.request.EnvironmentId, TenantId: d.tenantId };
                    }));
                }
                this.setState({
                    previews: previews,
                    selectedEnvironments: environments,
                    selectedTenantIds: tenantIds,
                    runbookRunRequests: runbookRunRequests,
                    promptVariablesForm: this.loadFormDetails(previews),
                    pendingInterruptions,
                    actionIdsToSkip: environmentIds.length === 0 ? [] : this.state.actionIdsToSkip,
                });
            }
        });
    };
    private async getAvailableRunsFromApi(environments: EnvironmentSelection[], tenantIds: string[], tenantTagsUsed: boolean): Promise<AvailableRunsApiResults> {
        const previews = await this.loadRunbookRunPreviews(environments.map((e) => e.environmentId), tenantIds);
        const promptVariablesForm = this.loadFormDetails(previews);
        // If the selected tenant-tags did not match any tenants, then we want to ensure checkCanDeploy is false and that
        // there are no runbookRuns created
        if (tenantTagsUsed && tenantIds.length === 0) {
            return {
                previews,
                allowRun: false,
                promptVariablesForm,
                requests: [],
            };
        }
        const runbookRunRequests = this.createRunbookRunsForEnvironments(environments, tenantIds, promptVariablesForm);
        return {
            previews,
            allowRun: true,
            promptVariablesForm,
            requests: runbookRunRequests,
        };
    }
    private setChangeRequestSettings(runbookRunRequests: DeploymentRequestModel[]) {
        const selectedEnvironmentIds = getEnvironmentIds(this.state.selectedEnvironments);
        const changeControlledEnvironments = getChangeControlledEnvironments(this.state.allStaticEnvironments.filter((e) => selectedEnvironmentIds.indexOf(e.Id) > -1));
        if (runbookRunRequests.length > 0 && changeControlledEnvironments.length > 0) {
            const runbookRunsByEnvironment = _.groupBy(runbookRunRequests, (x) => x.request.EnvironmentId);
            changeControlledEnvironments
                .map((e) => e.Id)
                .forEach((environmentId) => runbookRunsByEnvironment[environmentId].map((d) => d.request as CreateRunbookRunRequestResourceWithChangeRequestSettings).forEach((runbookRun) => (runbookRun.ChangeRequestSettings = this.state.changeRequestSettings ?? [])));
        }
    }
    private async setUseGuidedFailure(runbookRunRequests: DeploymentRequestModel[]) {
        const mode = this.state.guidedFailureMode;
        if (runbookRunRequests.length > 0) {
            if (mode === GuidedFailureMode.EnvironmentDefault) {
                const runbookRunsByEnvironment = _.groupBy(runbookRunRequests, (x) => x.request.EnvironmentId);
                const environmentIds = _.chain(runbookRunRequests)
                    .map((x) => x.request.EnvironmentId)
                    .uniq()
                    .value();
                // Keep track of the guided failure mode for any parent environments that we've
                // already requested so we don't request the same parent environment multiple times.
                const parentEnvironmentUseGuidedFailure: {
                    [key: string]: boolean;
                } = {};
                for (const environmentId of environmentIds) {
                    const environment = this.state.allEnvironments.find((e) => e.Id === environmentId);
                    if (!environment) {
                        throw new Error(`Environment with ID ${environmentId} not found.`);
                    }
                    let useGuidedFailureForEnvironment;
                    if (isEphemeralEnvironment(environment)) {
                        // Use guided failure for ephemeral environments is determined by the parent environment.
                        // Get the guided failure mode for the parent environment if we haven't already requested it.
                        if (parentEnvironmentUseGuidedFailure[environment.ParentEnvironmentId] === undefined) {
                            const parentEnvironment = await repository.ParentEnvironments.get({ SpaceId: environment.SpaceId, Id: environment.ParentEnvironmentId });
                            parentEnvironmentUseGuidedFailure[environment.ParentEnvironmentId] = parentEnvironment.UseGuidedFailure;
                        }
                        useGuidedFailureForEnvironment = parentEnvironmentUseGuidedFailure[environment.ParentEnvironmentId];
                    }
                    else {
                        useGuidedFailureForEnvironment = environment.UseGuidedFailure;
                    }
                    for (const runbookRun of runbookRunsByEnvironment[environmentId]) {
                        runbookRun.request.UseGuidedFailure = useGuidedFailureForEnvironment;
                    }
                }
            }
            else {
                for (const runbookRun of runbookRunRequests) {
                    runbookRun.request.UseGuidedFailure = mode === GuidedFailureMode.On;
                }
            }
        }
    }
    private onChangeRequestSettingsChanged = (updatedChangeRequestSettings: ChangeRequestSettings) => {
        let changeRequestSettings = _.cloneDeep(this.state.changeRequestSettings) ?? [];
        changeRequestSettings = changeRequestSettings.map((c) => (c.Type === updatedChangeRequestSettings.Type ? updatedChangeRequestSettings : c));
        if (changeRequestSettings.findIndex((c) => c.Type === updatedChangeRequestSettings.Type) < 0) {
            changeRequestSettings.push(updatedChangeRequestSettings);
        }
        this.setState({ changeRequestSettings });
    };
    private onPackageDownloadOptionChanged = (forcePackageDownload: boolean) => {
        const runbookRuns = _.cloneDeep(this.state.runbookRunRequests);
        runbookRuns.forEach((runbookRun) => (runbookRun.request.ForcePackageDownload = forcePackageDownload));
        this.setState({ runbookRunRequests: runbookRuns, forcePackageDownload });
    };
    private onFailTargetDiscoveryOptionChanged = (failTargetDiscovery: boolean) => {
        const runbookRuns = _.cloneDeep(this.state.runbookRunRequests);
        runbookRuns.forEach((runbookRun) => (runbookRun.request.FailTargetDiscovery = failTargetDiscovery));
        this.setState({ runbookRunRequests: runbookRuns, failTargetDiscovery });
    };
    private onDebugOptionChanged = (debugMode: DebugMode) => {
        const runbookRuns = _.cloneDeep(this.state.runbookRunRequests);
        runbookRuns.forEach((runbookRun) => (runbookRun.request.DebugMode = debugMode));
        this.setState({ runbookRunRequests: runbookRuns, debugMode });
    };
    private onPriorityChanged = (p: boolean) => {
        const priority = p ? PriorityMode.On : PriorityMode.Off;
        const runbookRuns = _.cloneDeep(this.state.runbookRunRequests);
        runbookRuns.forEach((runbookRun) => (runbookRun.request.Priority = priority));
        this.setState({ runbookRunRequests: runbookRuns, priority });
    };
    private onDeploymentScheduleChanged = (queueTime: Moment, queueTimeExpiry: Moment) => {
        const runbookRuns = _.cloneDeep(this.state.runbookRunRequests);
        runbookRuns.forEach((runbookRun) => {
            runbookRun.request.QueueTime = queueTime;
            runbookRun.request.QueueTimeExpiry = queueTimeExpiry;
        });
        this.setState({ runbookRunRequests: runbookRuns, queueTime, queueTimeExpiry });
    };
    private onActionIdsToSkipChanged = (excludedActionIdsToSkip: string[]) => {
        const runbookRuns = _.cloneDeep(this.state.runbookRunRequests);
        runbookRuns.forEach((runbookRun) => (runbookRun.request.SkipActions = excludedActionIdsToSkip));
        this.setState({ runbookRunRequests: runbookRuns, actionIdsToSkip: excludedActionIdsToSkip });
    };
    private onExcludeSpecificMachinesSelected = (machineInfo: DeploymentMachineInfo) => {
        this.setTargetMachineIds(machineInfo.deploymentType, machineInfo.id, machineInfo.machineIds, []);
    };
    private async loadEnvironments(ephemeralEnvironmentsAreEnabled: boolean, project: ProjectResource, runbookId: string, gitRef?: string) {
        if (ephemeralEnvironmentsAreEnabled) {
            const environmentsV2 = await repository.Runbooks.getRunbookEnvironmentsV2(project, runbookId, gitRef);
            return environmentsV2.Environments;
        }
        else {
            const environments = await repository.Runbooks.getRunbookEnvironments(project, runbookId, gitRef);
            return environments.map(mapFromEnvironmentResourceToEnvironmentV2Resource);
        }
    }
    private async loadAllTenants(runbook: RunbookResource) {
        if (runbook && (runbook.MultiTenancyMode === TenantedDeploymentMode.Tenanted || runbook.MultiTenancyMode === TenantedDeploymentMode.TenantedOrUntenanted)) {
            return isAllowed({ permission: Permission.TenantView, tenant: "*" }) ? repository.Tenants.all() : [];
        }
        return [];
    }
    private onIncludeSpecificMachinesSelected = (machineInfo: DeploymentMachineInfo) => {
        this.setTargetMachineIds(machineInfo.deploymentType, machineInfo.id, [], machineInfo.machineIds);
    };
    private onAllTargetsSelected = (machineInfo: DeploymentMachineInfo) => {
        this.setTargetMachineIds(machineInfo.deploymentType, machineInfo.id, [], []);
    };
    private setTargetMachineIds = (deploymentType: DeploymentType, targetId: string, excludedMachineIds: string[], specificMachineIds: string[]) => {
        const runbookRuns = _.cloneDeep(this.state.runbookRunRequests);
        const runbookRun = deploymentType === DeploymentType.Tenant ? runbookRuns.find((x) => x.tenantId === targetId) : runbookRuns.find((x) => x.request.EnvironmentId === targetId);
        runbookRun!.request.ExcludedMachineIds = excludedMachineIds;
        runbookRun!.request.SpecificMachineIds = specificMachineIds;
        this.setState({ runbookRunRequests: runbookRuns });
    };
    private isError(response: IExecutionResource | OctopusError): response is OctopusError {
        return (response as OctopusError).ErrorMessage !== undefined;
    }
    private createPackageKey(pkg: {
        ActionName: string;
        PackageReferenceName?: string;
    }) {
        let key = pkg.ActionName;
        if (pkg.PackageReferenceName) {
            key += `[${pkg.PackageReferenceName}]`;
        }
        return key;
    }
    private gitResourcesSummary() {
        const readOnlyGitResources = this.state.model.readonlyGitResources;
        if (!readOnlyGitResources || readOnlyGitResources.length === 0) {
            return Summary.placeholder("No Git Resources is included");
        }
        if (readOnlyGitResources.length === 1) {
            return Summary.summary("1 Git reference included");
        }
        return Summary.summary(`${readOnlyGitResources.length} Git references included`);
    }
    static displayName = "RunbookRunNowLayoutInternal";
}
function getRetryGoalForSelector(goal: RetryGoal, previousRunbookRun: RunbookRunResource) {
    if (goal.previousRunbookRunId !== previousRunbookRun.Id) {
        throw new Error("Invalid runbook run resource provided for environment selector retry");
    }
    return { previousRunbookRun };
}
interface RunbookRunNowLayoutProps extends GitRefQueryParamsProps {
    goal: RunGoal;
    runbookSnapshotId?: string;
}
export function RunbookRunNowLayout(props: RunbookRunNowLayoutProps) {
    const projectContext = useProjectContext();
    const runbookContext = useRunbookContext();
    const setExpanderState = useSetExpanderState();
    const project = projectContext.state.model;
    const runbook = runbookContext.state.runbook;
    const [gitRef, setGitRef, validationResult] = useProjectRunbooksGitRef(project, props.queryParams, props.setQueryParams);
    const newRunbookRunsListPageEnabled = useNewRunbookRunsListPageFeatureToggle(project);
    const ephemeralEnvironmentsAreEnabled = useEphemeralEnvironmentsEnabled();
    if (!project || !runbook) {
        return (<PageContent header={{ title: "" }} busy={true}>
                {null}
            </PageContent>);
    }
    return (<RunbookRunNowLayoutInternal newRunbookRunsListPageEnabled={newRunbookRunsListPageEnabled} ephemeralEnvironmentsAreEnabled={ephemeralEnvironmentsAreEnabled} project={project} runbook={runbook} gitRef={gitRef} gitRefError={validationResult?.Message} setExpanderState={setExpanderState} projectContextState={projectContext.state} runbookSnapshotId={props.runbookSnapshotId} queryParams={props.queryParams} setQueryParams={props.setQueryParams} goal={props.goal}/>);
}
export default RunbookRunNowLayout;
